import { __assign, __generator } from "tslib";
import { put, call, select, all, fork, cancelled, delay, } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { initDeviationPage } from '../../DeviationPage/redux/actions';
import { DeviationResourceType } from '../../types/deviation';
import { request } from '../../xhr/request';
import { getItemIdsForPreload } from './selectors';
import { getExtendedDeviationById, getDeviationIdFromNormalizedId, } from '../../redux/deviations/selectors';
import { getCommentCursorFromQuery } from '../../CommentThread/helpers';
import history from '../../redux/routing/history';
import { isExtendedDeviationFullyLoaded } from '../../DeviationPage/redux/helpers';
import { ConfigSelectors } from '../../config';
var logger = ddt.createLogger('duperbrowse');
function getDeviationPageTypeFromTypeId(typeId) {
    switch (typeId) {
        case DeviationResourceType.JOURNAL:
            return 'journal';
        case DeviationResourceType.COMMISSION:
            return 'commission';
        case DeviationResourceType.POLL:
            return 'poll';
        case DeviationResourceType.STATUS:
            return 'status-update';
        case DeviationResourceType.TIER:
            // TODO member_subscriptions clean up any when backend supports tiers for related content
            return 'tier';
        default:
            return 'art';
    }
}
function loadDeviation(itemId, preload, currentDeviationId) {
    var deviation, csrf, queryParams, parsedQuery_1, params, _a, result;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getExtendedDeviationById, itemId)];
            case 1:
                deviation = _c.sent();
                if (!deviation) {
                    logger.error('Deviation not found', itemId);
                    return [2 /*return*/, false];
                }
                if (isExtendedDeviationFullyLoaded(deviation)) {
                    // already loaded, we good
                    logger.log('Deviation already loaded, bailing', itemId);
                    return [2 /*return*/, false];
                }
                logger.log('Loading deviation', itemId, { preload: preload, currentDeviationId: currentDeviationId });
                _c.label = 2;
            case 2:
                _c.trys.push([2, , 8, 10]);
                return [4 /*yield*/, select(ConfigSelectors.key('csrfToken'))];
            case 3:
                csrf = _c.sent();
                queryParams = new URLSearchParams(history.location.search);
                parsedQuery_1 = {};
                queryParams.forEach(function (value, key) { return (parsedQuery_1[key] = value); });
                params = {
                    deviationid: deviation.deviationId,
                    username: deviation.author && deviation.author.username,
                    type: getDeviationPageTypeFromTypeId(deviation.typeId),
                    include_session: false,
                    comments_cursor: getCommentCursorFromQuery(parsedQuery_1, {
                        itemId: deviation.deviationId,
                    }),
                    csrf_token: csrf,
                };
                if (!preload) return [3 /*break*/, 5];
                params.preload = true;
                if (!currentDeviationId) return [3 /*break*/, 5];
                _a = params;
                return [4 /*yield*/, select(getDeviationIdFromNormalizedId, currentDeviationId)];
            case 4:
                _a.current_id = _c.sent();
                _c.label = 5;
            case 5: return [4 /*yield*/, call(request, {
                    method: 'get',
                    url: 'deviation/extended_fetch',
                    params: params,
                }, function () {
                    if (process.env.NODE_ENV !== 'production') {
                        // eslint-disable-next-line
                        var chance = require('chance').Chance();
                        // eslint-disable-next-line
                        var _a = require('@wix/da-sample-data'), Fake = _a.Fake, commentThreads = _a.commentThreads;
                        return {
                            deviation: Fake.extendDeviation(deviation, {}),
                            comments: __assign(__assign({}, chance.pickone(commentThreads)), { commentableItemid: deviation.deviationId, commentableTypeid: deviation.typeId }),
                        };
                    }
                    return false;
                })];
            case 6:
                result = _c.sent();
                if (!result || !result.deviation) {
                    if (result && !result.deviation) {
                        ddt.alert('debug', 'Loaded bad deviation', ['debug'], {
                            result: result,
                            params: params,
                        });
                    }
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, put(initDeviationPage(result.deviation, result.comments, ((_b = result.ads) === null || _b === void 0 ? void 0 : _b.unsafe) || 'unlikely'))];
            case 7:
                _c.sent();
                return [2 /*return*/, true];
            case 8: return [4 /*yield*/, cancelled()];
            case 9:
                if (_c.sent()) {
                    logger.log('Loading canceled', deviation, { preload: preload });
                }
                return [7 /*endfinally*/];
            case 10: return [2 /*return*/];
        }
    });
}
function getLoader(itemSchema) {
    switch (itemSchema) {
        case 'deviation':
            return loadDeviation;
        default:
    }
}
export function handleLoading(_a) {
    var loader, wasRealLoad, currentItem, navigation, preloadEffects;
    var _b = _a.payload, itemId = _b.itemId, itemSchema = _b.itemSchema, preloadDirection = _b.preloadDirection;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, delay(200)];
            case 1:
                _c.sent(); // debounce
                loader = getLoader(itemSchema);
                if (!loader) {
                    logger.log('No loader found', itemSchema);
                    return [2 /*return*/];
                }
                logger.log('Starting main load', itemId);
                return [4 /*yield*/, call(loader, itemId, false)];
            case 2:
                wasRealLoad = _c.sent();
                currentItem = wasRealLoad ? undefined : itemId;
                return [4 /*yield*/, select(getItemIdsForPreload, preloadDirection)];
            case 3:
                navigation = _c.sent();
                preloadEffects = navigation.map(function (item) {
                    return fork(loader, item, true, currentItem);
                });
                logger.log('Forking preloads', navigation);
                // here we fork out the preloaders to do their thing async
                return [4 /*yield*/, all(preloadEffects)];
            case 4:
                // here we fork out the preloaders to do their thing async
                _c.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=loader.js.map